goog.provide('el8.appservice.headline');

goog.require('el8.app.pageLayout');



el8.appservice.headline = function(opts) {
    opts = opts || {};

    this._wrapperFn = opts.wrapperFn;
    this._wrapperId = opts.wrapperId;
    this._contentFn = opts.contentFn || null;
    this._clickMap = opts.clickMap || null;

    this._isShowing = false;

    // acceptable options are 'above' or 'below'
    // describes whether the headline goes above or below the blue header
    this._placement = opts.placement || 'above';
};

el8.appservice.headline.prototype.show = function() {

    var $wrapper = $(this._wrapperFn());
    $wrapper.attr('id', this._wrapperId);

    if (this._placement === 'below') {
        $('#page-header').after($wrapper);
    } else {
        $('#page-'+el8Globals['APP']).prepend($wrapper);
    }

    var container = $('#'+this._wrapperId).addClass('app-headline');
    if (this._contentFn) {
        $('.headline-contents', container).html(this._contentFn());
    }
    el8.app.pageLayout.trigger('el8_resizeApp');
    if (this._clickMap) {
        var that = this;
        container.on('click', '.headline-trigger',  function(e) {
            var name = $(this).attr('data-name');
            if (that._clickMap[name]) { that._clickMap[name](container); }
        });
    }

    this._isShowing = true;
    return container;

};

el8.appservice.headline.prototype.hide = function() {
    var $wrapper = $('#'+this._wrapperId);
    $wrapper.hide(300, function() {
        $wrapper.remove();
        el8.app.pageLayout.trigger('el8_resizeApp');
    });
    this._isShowing = false;
};

el8.appservice.headline.prototype.isShowing = function() {
    return this._isShowing;
}
